/**
 * Dashboard section wrapper: header and the middle slot for {@link CalendarView}.
 */

import * as React from 'react';
import { Calendar, RefreshCw } from 'lucide-react';
import { CalendarSyncModal } from '@/components/calendar/CalendarSyncModal';
import { CalendarView } from '@/components/calendar/CalendarView';
import { Button } from '@/components/forms/Button';
import { CALENDAR_SYNC_ENABLED } from '@/config/features';
import type { ElementWidth } from '@/types/interface-elements.types';

/** Props for {@link CalendarSection}. */
interface CalendarSectionProps {
  layoutWidth?: ElementWidth;
}

/** Dashboard widget: calendar with a sync action in the section header. */
export const CalendarSection: React.FC<CalendarSectionProps> = ({ layoutWidth = 'full' }) => {
  const [syncOpen, setSyncOpen] = React.useState(false);

  function handleOpenSync(): void {
    setSyncOpen(true);
  }

  function handleCloseSync(): void {
    setSyncOpen(false);
  }

  return (
    <div className="space-y-4">
      <div className="section-header">
        <div className="flex items-center gap-2">
          <Calendar className="w-5 h-5 text-[var(--color-1-nuance-1)]" />
          <h3 className="text-xl font-semibold text-[var(--color-1-nuance-1)]">Calendrier</h3>
        </div>
        {CALENDAR_SYNC_ENABLED ? (
          <div className="section-actions">
            <Button
              preset="section-action"
              icon={RefreshCw}
              tooltipText="Synchroniser"
              aria-label="Synchroniser"
              onClick={handleOpenSync}
            />
          </div>
        ) : null}
      </div>
      <div>
        <CalendarView layoutWidth={layoutWidth} />
      </div>
      {CALENDAR_SYNC_ENABLED ? (
        <CalendarSyncModal open={syncOpen} onClose={handleCloseSync} />
      ) : null}
    </div>
  );
};
